<template>
  <div>
    <v2-row noSpace>
      <v2-col class="w-full relative" style="height: 400px">
        <div :class="['mt-0 h-full v2-backoffice-uppy']" :id="'trigger-envivo-upload-box-' + component.uid"></div>
        <v2-uppy-upload
          :withMediaLibraryButton="true"
          :id="component.uid"
          :locale="teams[$route.params.team].account.locale"
          :target="'#trigger-envivo-upload-box-' + component.uid"
          componentTagname="tb-image"
          :inline="true"
          :hideUploadButton="true"
          :create-file="createNewFile"
          :uploadConfig="uploadConfig"
          @completed="createRelation"
          @openMediaLibrary="openMediaLibrary"
        ></v2-uppy-upload>
      </v2-col>
      <v2-col class="w-full" v-if="component.relations.length">
        <v2-lazy-load
          :isLoading="!isReady"
          :image="imageUrl"
          bgColor="rgba(241, 242, 246, 1)"
          class="flex justify-center"
        ></v2-lazy-load>
      </v2-col>
    </v2-row>
  </div>
</template>

<script>
import teamAbilities from "@/mixins/teamAbilities.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "QuickLaunchImage",
  mixins: [teamAbilities],
  props: {
    component: Object,
  },
  data() {
    return {
      uploadConfig: {
        max_files: -1,
      },
      imageComponent: null,
      item: null,
      amountTry: 10,
      timeWaitStart: 3000,
      timer: null,
      imageUrl: "",
    };
  },
  created() {
    this.imageComponent = this.component;
    if (this.imageComponent.relations.length > 0) {
      this.item = this.imageComponent.relations[0];
    }
    if (this.item) {
      this.untilReady();
    }
    this.uploadConfig.max_size = this.teamUploadConfig().max_size;
    this.$eventbus.$on("closeMediaLibrary", this.handleMediaLibrarySelector);
  },
  destroyed() {
    this.$eventbus.$off("closeMediaLibrary");
  },
  methods: {
    ...mapActions([
      "getProjectComponent",
      "createComponentRelation",
      "createProjectFiles",
      "getProjectFileImagePreview",
      "getTemplateFilePreview",
      "getLibraryImagePreview",
      "getProjectFile",
      "deleteComponentRelation",
    ]),
    createNewFile(data) {
      return new Promise((resolve, reject) => {
        var vm = this;
        data.params.project = this.currentProject.uid;
        data.params.component = this.imageComponent.uid;
        data.customLoading = true;
        vm.createProjectFiles(data)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            vm.$snotify.error(vm.$t("quickLaunch.toasts.uploadFile.error"), vm.$t("toasts.error"), {
              timeout: 0,
              icon: vm.$errorIcon,
            });
            reject(err);
          });
      });
    },
    createRelation(data) {
      const vm = this;
      if (this.imageComponent.relations && this.imageComponent.relations.length > 0) {
        vm.removeRelation(() => {
          vm.newRelation(data);
        });
      } else {
        vm.newRelation(data);
      }
    },
    removeRelation(cb) {
      const vm = this;
      const params = {
        project: vm.currentProject.uid,
        component: vm.imageComponent.uid,
        relation: vm.imageComponent.relations[0].relationUid,
      };
      vm.deleteComponentRelation({ customLoading: true, params })
        .then(() => {
          cb();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    newRelation(data) {
      const vm = this;
      const d = {
        customLoading: true,
        params: {
          project: this.currentProject.uid,
          component: this.imageComponent.uid,
        },
        data: {
          type: data.type ? data.type : "projectfile",
          uid: data.uid,
        },
      };
      vm.createComponentRelation(d)
        .then(() => {
          vm.$snotify.success(vm.$t("quickLaunch.toasts.uploadFile.success"), vm.$t("toasts.success"), {
            icon: vm.$successIcon,
          });
          vm.reloadComponent();
        })
        .catch(() => {
          vm.$snotify.error(vm.$t("quickLaunch.toasts.uploadFile.error"), vm.$t("toasts.error"), {
            timeout: 0,
            icon: vm.$errorIcon,
          });
        });
    },
    reloadComponent() {
      const vm = this;
      vm.getProjectComponent({
        customLoading: true,
        params: {
          project: vm.currentProject.uid,
          component: vm.imageComponent.uid,
        },
      }).then((res) => {
        vm.imageComponent = res;
        vm.item = res.relations[0];
        vm.untilReady();
      });
    },
    getItemPreview() {
      this.imageUrl = "";
      const data = {
        team: this.$route.params.team,
        project: this.currentProject.uid,
        template: this.currentProject.template.uid,
        file: this.item.uid,
        customLoading: true,
        folder: this.item.folder,
        params: {
          width: Math.round(290 / this.item.ratio),
          height: "290",
        },
      };
      if (this.imageComponent.relations[0].library_type === "project") {
        if (this.isConverted && this.item.preview.image) {
          this.getProjectFileImagePreview(data).then((res) => {
            this.imageUrl = res;
          });
        } else {
          this.imageUrl = "";
        }
      } else if (this.imageComponent.relations[0].library_type === "template") {
        if (this.isConverted && this.item.preview.image) {
          this.getTemplateFilePreview(data).then((res) => {
            this.imageUrl = res;
          });
        } else {
          this.imageUrl = "";
        }
      } else if (this.imageComponent.relations[0].library_type === "library") {
        if (this.isConverted && this.item.preview.image) {
          this.getLibraryImagePreview(data).then((res) => {
            this.imageUrl = res;
          });
        } else {
          this.imageUrl = "";
        }
      }
    },
    untilReady() {
      const data = {
        file: this.item.uid,
        project: this.currentProject.uid,
        customLoading: true,
      };
      if (!this.isReady) {
        const vm = this;
        vm.timer = setTimeout(function () {
          vm.getProjectFile(data)
            .then((response) => {
              vm.item = response;
              vm.amountTry = vm.amountTry - 1;
              if (vm.amountTry <= 0) {
                vm.amountTry = 10;
                vm.timeWaitStart = vm.timeWaitStart + 60000;
              }
              vm.untilReady();
            })
            .catch();
        }, vm.timeWaitStart);
      } else {
        this.getItemPreview();
      }
    },
    isConvertedCalculate(item) {
      return this.statiBits ? this.$h.globalIsBitSet(item.status, this.statiBits.CONVERTED.bit) : false;
    },
    isReadyCalculate(item) {
      if (this.statiBits && item.status) {
        return (
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "VIRUS_SCANNING" &&
          this.$h.globalCheckFileStatus(item.status, this.statiBits) !== "CONVERTING"
        );
      } else {
        return false;
      }
    },
    openMediaLibrary() {
      const data = {
        component: this.component.uid,
        files: this.fileList,
        whitelist: ["image"],
        autoClose: true,
      };
      this.$eventbus.$emit("openMediaLibrary", data);
    },
    handleMediaLibrarySelector(data) {
      if (data.component === this.component.uid) {
        console.log("handleMediaLibrarySelector", data);
        data.selected.forEach((file) => {
          this.createRelation({ uid: file, type: "libraryfile" });
        });
      }
    },
  },
  computed: {
    isConverted() {
      return this.isConvertedCalculate(this.item);
    },
    isReady() {
      return this.isReadyCalculate(this.item);
    },
    ...mapGetters({
      teams: "auth_get_teams",
      currentProject: "projects_get_current_project",
      statiBits: "global_get_fileStatiBits",
    }),
  },
};
</script>
